import React from 'react';

import {AvatarShape, AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {AvatarWithName} from 'ui-library/avatar/AvatarWithName';

export interface SampleCreatorInfoProps {
  creator: {
    handle: string;
  };
}

export default function SampleCreatorInfo(props: SampleCreatorInfoProps): JSX.Element {
  return (
    <AvatarWithName
      avatarInfo={props.creator}
      size={AvatarSize.XXSMALL}
      shape={AvatarShape.CIRCLE}
      showTooltip={false}
    />
  );
}
